import classNames from "classnames";
import React from "react";
import { useIntl } from "react-intl";
import LanguageSwitch from "../language/LanguageSwitch";

import "./styles.styl";

export default function Footer(props) {
  const {
    privacyPage,
    logoSmallUrl,
    className,
    gmbhName,
    onFooterLinkClick,
    currentLang,
    ...rest
  } = props;
  const intl = useIntl();
  const handleSettingsTabClick = (e, value) => {
    e.preventDefault();
    if (onFooterLinkClick) {
      onFooterLinkClick(value, true);
    }
  };

  // Renders a footer with links to "Impressum", "Datenschutz", and "AGB".
  // Each link, when clicked, invokes the handleSettingsTabClick function
  // with a specific index to identify the clicked tab.
  // NOTE: If additional tabs are added or the order changes, ensure that the
  // tabIndex values in footerLinksData are updated accordingly.
  const footerLinksData = [
    {
      label: intl.formatMessage({ id: "impressum" }),
      href: "#impressum",
      tabIndex: 10,
    },
    {
      label: intl.formatMessage({ id: "dataPrivacy" }),
      href: "#datenschutz",
      tabIndex: 12,
    },
    {
      label: intl.formatMessage({ id: "termsAndConditionsHc" }),
      href: "#agb",
      tabIndex: 11,
    },
  ];

  return (
    <div className={classNames("footer-slim", className)} {...rest}>
      {footerLinksData.map((link) => (
        <a
          key={link.href}
          href={link.href}
          onClick={(e) => handleSettingsTabClick(e, link.tabIndex)}
        >
          {link.label}
        </a>
      ))}
      <div className="lang">
        <LanguageSwitch currentLang={currentLang} />
      </div>
    </div>
  );
}
